import React from "react";
import PropTypes from "prop-types";
import useSaveResponse from "core-web/hooks/useSaveResponse";
import transformAlgoliaProduct from "core-web/utils/dataTransformers/transformAlgoliaProduct";
import { sortArrayBasedOnAnotherArray } from "core-web/utils/sorting";
import ProductsContainer from "core-web/containers/ProductsContainer";
import parseProductSelection from "theme/libs/wordpress/utils/transformProductSelection";
import ModuleMarginWrapper from "theme/components/wrappers/ModuleMarginWrapper";
import ProductSliderBlock from "theme/libs/wordpress/content/cmsBlocks/ProductSliderBlock";

const ProductSliderModule = ({ content, isFirstModule }) => {
    const { product_selection: productsSelection, ...blockContent } = content?.data || {};

    if (productsSelection?.product_rows?.length) {
        productsSelection.products = productsSelection.product_rows.reduce(
            (allProducts, { products }) => allProducts.concat(products),
            [],
        );
    }

    const [useResponse, saveResponse] = useSaveResponse();

    const parsed = parseProductSelection(productsSelection?.[0]) || {};
    const { type, values, selection, pageSize, isDistinct } = parsed;
    const filters = {
        default: selection || [],
        selected: [],
    };

    return (
        <ModuleMarginWrapper>
            <ProductsContainer
                distinct={isDistinct}
                pageSize={pageSize}
                ids={type === "id" ? values : []}
                filters={filters}
                render={({ response }) => {
                    saveResponse(response);
                    const products = useResponse?.current?.products || [];
                    const sortedProducts =
                        type === "id" ? sortArrayBasedOnAnotherArray(products, values, "objectID") : products;
                    const transformedProducts = sortedProducts.map((product) =>
                        transformAlgoliaProduct(product, null, isDistinct),
                    );

                    return (
                        <ProductSliderBlock
                            content={blockContent}
                            isFirstModule={isFirstModule}
                            products={transformedProducts}
                            productsAmount={transformedProducts?.length || pageSize}
                        />
                    );
                }}
            />
        </ModuleMarginWrapper>
    );
};

ProductSliderModule.propTypes = {
    content: PropTypes.object,
    isFirstModule: PropTypes.bool,
};

ProductSliderModule.defaultProps = {
    content: undefined,
    isFirstModule: false,
};

export default ProductSliderModule;
